import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCapacityEmbedRoute: InvariantJiraRoute = {
	name: 'software-capacity-embed',
	path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/embed',
	query: [],
};
